var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCisco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "All_Logos",
    "data-name": "All Logos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 380 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_cisco") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 141.75,
    y: 99.24,
    width: 9.73,
    height: 38.61,
    fill: "#049fd9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230,110.3a17,17,0,0,0-8.17-2c-6.31,0-10.67,4.4-10.67,10.31,0,5.73,4.18,10.31,10.67,10.31a17.12,17.12,0,0,0,8.17-2v10.35a30.43,30.43,0,0,1-8.88,1.38c-11,0-20.58-7.55-20.58-20,0-11.51,8.71-20,20.58-20A29.91,29.91,0,0,1,230,100Z",
    fill: "#049fd9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.37,110.3a16.78,16.78,0,0,0-8.17-2c-6.31,0-10.67,4.4-10.67,10.31,0,5.73,4.18,10.31,10.67,10.31a17.12,17.12,0,0,0,8.17-2v10.35a30.16,30.16,0,0,1-8.88,1.38c-10.93,0-20.58-7.55-20.58-20,0-11.51,8.71-20,20.58-20a29.91,29.91,0,0,1,8.88,1.38Z",
    fill: "#049fd9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M281.09,118.52c0,11.07-8.54,20-20.4,20s-20.39-8.93-20.39-20,8.53-20,20.39-20,20.4,9,20.4,20m-20.4-10.13a10.16,10.16,0,1,0,10.09,10.13,10,10,0,0,0-10.09-10.13",
    fill: "#049fd9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.44,108a32.57,32.57,0,0,0-7.59-1.2c-3.91,0-6,1.29-6,3.15,0,2.36,2.85,3.16,4.49,3.69l2.67.84c6.31,2,9.2,6.36,9.2,11.07,0,9.68-8.54,13-16,13a55.44,55.44,0,0,1-10.53-1.06v-8.89a36.31,36.31,0,0,0,9.2,1.42c4.84,0,7.06-1.42,7.06-3.6,0-2-1.91-3.06-4.35-3.86-.58-.18-1.47-.49-2.09-.67-5.42-1.73-9.95-4.89-9.95-11.29,0-7.19,5.42-12.08,14.39-12.08a40.83,40.83,0,0,1,9.51,1.24V108Z",
    fill: "#049fd9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.61,57.74a4.85,4.85,0,0,0-9.69,0V67.87a4.85,4.85,0,0,0,9.69,0Z",
    fill: "#049fd9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.18,44.45a4.85,4.85,0,0,0-9.69,0V67.87a4.85,4.85,0,0,0,9.69,0Z",
    fill: "#049fd9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.7,26.24a4.84,4.84,0,0,0-9.68,0V77.51a4.84,4.84,0,1,0,9.68,0Z",
    fill: "#049fd9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168.27,44.45a4.84,4.84,0,0,0-9.68,0V67.87a4.84,4.84,0,0,0,9.68,0Z",
    fill: "#049fd9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.84,57.74a4.82,4.82,0,0,0-9.64,0V67.87a4.82,4.82,0,1,0,9.64,0Z",
    fill: "#049fd9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M221.41,44.45a4.84,4.84,0,0,0-9.68,0V67.87a4.84,4.84,0,0,0,9.68,0Z",
    fill: "#049fd9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M248,26.24a4.84,4.84,0,0,0-9.68,0V77.51a4.84,4.84,0,0,0,9.68,0Z",
    fill: "#049fd9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M274.55,44.45a4.87,4.87,0,0,0-9.73,0V67.87a4.87,4.87,0,0,0,9.73,0Z",
    fill: "#049fd9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M301.08,57.74a4.85,4.85,0,0,0-9.69,0V67.87a4.85,4.85,0,0,0,9.69,0Z",
    fill: "#049fd9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCisco);
export default __webpack_public_path__ + "static/media/logo_cisco.2ad9271511d0e3bad5f6199bee3748e7.svg";
export { ForwardRef as ReactComponent };